<template>
  <BaseSideBar>
    <!-- list of Statuses -->
    <transition-group tag="div" name="menu-open-mobile">
      <SideBarTitle
        key="title"
        :title="$t('sideBar.orders.orderStatus')"
        mode="orders"
        iconName="mdi-text-box-search-outline"
        :isSideBarTitleShown="!needToCloseSideBar"
      />

      <SideBarList
        key="list"
        :isSideBarListDisplay="!needToCloseSideBar"
        :Statuses="Statuses"
        mode="orders"
      />
    </transition-group>
  </BaseSideBar>
</template>

<script>
import BaseSideBar from "./BaseSideBar.vue";

import { mapGetters } from "vuex";
import SideBarTitle from "./SideBarTitle.vue";
import SideBarList from "./SideBarList.vue";

export default {
  components: {
    BaseSideBar,
    SideBarTitle,
    SideBarList,
  },
  data() {
    return {};
  },
  computed: {
    isLangHebrew() {
      return this.getUserLang == "he" ? true : false;
    },
    needToCloseSideBar() {
      if (
        (this.$store.getters.isMobile || this.$store.getters.isTablet) &&
        !this.$store.state.openMenu
      ) {
        // this.$store.commit("toggleMenu");
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters({
      Statuses: "Orders/getOrderStatuses",
      getUserLang: "AuthModule/getUserLang",
    }),
    getParamStatus() {
      return this.$route.params.status;
    },
  },
};
</script>

<style scoped lang="scss">
.title-section {
  padding: 0px 20px 0px 20px;
}
.orders-icon {
  color: $ordersMainColor;
  background-color: #44a5e233;
  border-radius: 50%;
  padding: 17px;
}
@media (max-width: 601px) {
  .side-bar-container {
    padding: unset;
  }
}
.menu-open-mobile-enter-from,
.menu-open-mobile-leave-to {
  max-height: 0px;
}
.menu-open-mobile-enter-active,
.menu-open-mobile-leave-active {
  transition: all 0.2s ease;
  overflow: hidden;
}
.menu-open-mobile-enter-to,
.menu-open-mobile-leave-from {
  max-height: 1000px;
}
h2 {
  font-size: 30px;
  font-weight: 700;
  color: $ordersMainColor;
  line-height: 35.55px;
  text-align: right;
}

.material-icons {
  font-size: unset;
}
.collection-item {
  text-decoration: none;
  span {
    font-weight: 400;
    padding: 10px;
  }
}
.menu-collection {
  .v-list-item-title {
    font-size: $mediumTextSize;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    color: $statusListColor;
  }
}
</style>
